import { createContext, useContext } from 'react';
import { type AuthContextType } from '../types';

// Kept separate from AuthProvider so that file exports only its component,
// which is what lets fast refresh work on it.
export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = (): AuthContextType => {
	const context = useContext(AuthContext);
	if (!context) throw new Error('useAuth must be used within AuthProvider');
	return context;
};
